const SERVER_BASE_URL = "http://localhost:3001";
//"https://cve-back.vercel.app"
//http://localhost:3001
//https://back-test-one.vercel.app
module.exports = { SERVER_BASE_URL };
